import React from "react";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { usePostHog } from "posthog-js/react";
import Modal from "~/components-shared/Modal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import styled from "styled-components";
import { Alert } from "~/components-shared";
import memberSelectors from "~/store/members/selectors";
import membersActionCreators from "~/store/members/actions";
import inviteTemporaryMemberSchema from "~/forms/InviteTemporaryMemberForm/inviteTemporaryMemberSchema";
import InviteTemporaryMemberForm from "~/forms/InviteTemporaryMemberForm";
import { RoutesEnum, StatusStateEnum } from "~/types/enums";
import toastsActionCreators from "~/store/toasts/actions";
import { useHistory } from "react-router-dom";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const InviteTemporaryMemberModal = () => {
  const {
    t
  } = useTranslation();
  const member = useSelector(memberSelectors.getSelected);
  const memberId = member?.id || "";
  const posthog = usePostHog();
  const status = useSelector(memberSelectors.getStatusByInvitation(memberId));
  const error = useSelector(memberSelectors.getErrorByInvitation(memberId));
  const history = useHistory();
  const dispatch = useDispatch();
  const defaultValues = {
    roleId: ""
  };
  const {
    handleSubmit,
    control
  } = useForm({
    resolver: yupResolver(inviteTemporaryMemberSchema),
    defaultValues
  });
  const onSubmit = handleSubmit(data => {
    dispatch(membersActionCreators.inviteStarted(memberId, data, _ref => {
      let {
        data: complete
      } = _ref;
      if (complete) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("InviteTemporaryMemberModal.memberInvited", {
            name: `${member?.firstName} ${member?.lastName}`,
            route: RoutesEnum.INVITATIONS
          }),
          timeout: 10000,
          actions: [{
            icon: "external-link",
            onClick: () => history.push(RoutesEnum.INVITATIONS)
          }]
        }));
        posthog.capture(`Member Invited to Joyn ("${member?.firstName} ${member?.lastName}")`, {
          memberId,
          roleId: data.roleId
        });
      }
    }));
  });
  const onCancel = () => {
    posthog.capture(`Member Invite – Cancel ("${member?.firstName} ${member?.lastName}")`);
    dispatch(membersActionCreators.actionChanged(undefined, undefined));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("InviteTemporaryMemberModal.inviteMember"),
    onClose: onCancel,
    maxWidth: "500px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(InviteTemporaryMemberForm, {
    control: control
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    loading: status === StatusStateEnum.LOADING,
    onClick: onSubmit,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true
  }, t("common.actions.invite")))));
};
export default InviteTemporaryMemberModal;